module.exports = __webpack_public_path__ + "img/枪王射击.8c9c4e70.jpg";